/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Joymen Rebello",
  title: "Hello all, I'm Joymen",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with Java / Spring / JavaScript / Rest APIs / React Js / React Native / Next Js and many other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1_Myf6FY3UKDBrz99BHb7DXCtn3RPEu11/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/JoymenR",
  linkedin: "https://www.linkedin.com/in/joymen-rebello/",
  gmail: "rjoymen@gmail.com",
  instagram: "https://www.instagram.com/joymen_1725/",
  facebook: "https://www.facebook.com/joymen.rebello.1/",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Creative web developer dedicated in building user-centric and high-impactful Web Applications",
  skills: [
    emoji(
      "⚡ Strong knowledge of Designing, Analyzing and Developing Applications with MVC Architecture. "
    ),
    emoji(
      "⚡ Proficient in managing the development process including planning, estimation and scheduling."
    ),
    emoji(
      "⚡ Ability to handle multiple assignments efficiently under Tight Deadlines while meeting quality standards"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "BOOTSTRAP",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-apple"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Angular Js",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "SQL Database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "WordPress",
      fontAwesomeClassname: "fab fa-wordpress"
    },
    {
      skillName: "Google Analytics",
      fontAwesomeClassname: "fas fa-chart-line"
    }
,
    {
      skillName: "Python",
      fontAwesomeClassname: "fa-brands fa-python"
    }
,
    {
      skillName: "Next JS",
      fontAwesomeClassname: "fa-solid fa-n"
    }
,
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fa-brands fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Lithan Academy",
      logo: require("./assets/images/lithanLogo.jpg"),
      subHeader: "Pearson BTEC–Level 5 Higher National Diploma in Computing",
      duration: "2019-2022"
      // desc: "Developed many Pratical Web Applications.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Alpha Junior College of Science",
      logo: require("./assets/images/alplogo.jpg"),
      subHeader: "Higher Secondary Certification (HSC)",
      duration: "2017-2019"
      // desc: "Developed many Pratical Web Applications.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Our Lady Of Health High School",
      logo: require("./assets/images/olhsLogo.png"),
      subHeader: "Secondary School Certificate (SSC)",
      duration: "2005-2017"
      // desc: "Developed many Pratical Web Applications.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    }
    // {
    //   schoolName: "Stanford University",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Web Developer Intern",
      company: "Akaraah Media Tech",
      companylogo: require("./assets/images/akLogo.jpg"),
      date: "October 2020 – March 2021",
      desc: "Brought on board to Design & Develop Several Wordpress Sites for clients as well as managed the SEO & Analytics for them.   ",
      descBullets: [
        "Boosted the Search Engine Ranking of Siimsar Hospital from 27th to 3rd Rank.",
        "Increased the GTmetrix Performance scores of  Ecostar Business by 28%."
      ]
    },
    {
      role: "Full Stack Software Engineer",
      company: "Opoyi",
      companylogo: require("./assets/images/opoyi-logo.svg"),
      date: "November 2021 – December 2022",
      desc: "Brought on board to Develop an Android & IOS Application using React Native, Improvements on the frontend Portal as well as on Backend.   ",
      descBullets: [
        "Developed the entire Login/ Signup Process via Social Login(Google & Facebook), Mobile Login & Email Login For the Application.",
        "Developed a cross-platform mobile application using 𝗥𝗲𝗮𝗰𝘁 𝗡𝗮𝘁𝗶𝘃𝗲 for both Android & iOS platforms."
,
        "Collaborated on a major 𝗨𝗥𝗟 𝗿𝗲𝘀𝘁𝗿𝘂𝗰𝘁𝘂𝗿𝗶𝗻𝗴 project using 𝗥𝗲𝗮𝗰𝘁, 𝗡𝗲𝘅𝘁.𝗷𝘀, 𝗗𝗷𝗮𝗻𝗴𝗼, 𝗮𝗻𝗱 𝗣𝘆𝘁𝗵𝗼𝗻."
,
        "Developed efficient 𝗚𝗿𝗮𝗽𝗵𝗤𝗟 queries and mutations."
,
        "Enhanced website 𝗣𝗮𝗴𝗲𝗦𝗽𝗲𝗲𝗱 for A+/90+ scores."
,
        "Developed 𝗣𝘆𝘁𝗵𝗼𝗻 scripts and implemented new features in the 𝗗𝗷𝗮𝗻𝗴𝗼 Backend for efficient performance improvements and data modifications."
,
        "Utilized 𝗘𝗹𝗮𝘀𝘁𝗶𝗰𝘀𝗲𝗮𝗿𝗰𝗵 for efficient CRUD operations and faster query responses."
,
        "Utilized 𝗗𝘆𝗻𝗮𝗺𝗼𝗗𝗕 to process large amounts of data on the portal."
,
        "Developed comprehensive 𝗥𝗦𝗦 𝗳𝗲𝗲𝗱𝘀 for Numerous Clients using Django syndication framework."
,
        "Developed 𝗥𝗘𝗦𝗧 𝗔𝗣𝗜'𝘀 for AI newsroom using Django DRF Framework."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "rjoymen@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
